import * as React from 'react';
import {Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';

import {Checklist, ChecklistState} from '../api/dtos/dtos';
import locales from "../locales";
import ChecklistImageFormRow from "./ChecklistImageFormRow";

interface ChecklistImagesFormProps extends FormComponentProps {
  rentalChecklist?: Checklist;
  returnalChecklist?: Checklist;
  editable: boolean;
  onImagesChange?: () => void;
}

class ChecklistImagesForm extends React.Component<ChecklistImagesFormProps, {}> {

  public render() {
    const {form, rentalChecklist, returnalChecklist, editable, onImagesChange} = this.props;

    const rentalEditable = editable && !returnalChecklist && rentalChecklist?.state !== ChecklistState.IGNORED;
    const returnalEditable = editable && returnalChecklist !== undefined && returnalChecklist?.state !== ChecklistState.IGNORED;

    return (
      <div style={{flex: '1 1 300px', margin: '0 auto', maxWidth: 916}}>
        <Form>
          <ChecklistImageFormRow
            title={locales.images}
            rentalChecklist={rentalChecklist}
            returnalChecklist={returnalChecklist}
            rentalEditable={rentalEditable}
            returnalEditable={returnalEditable}
            form={form}
            required={false}
            onChange={onImagesChange}
          />
        </Form>
      </div>
    );
  }
}

export default Form.create<ChecklistImagesFormProps>()(ChecklistImagesForm);




// WEBPACK FOOTER //
// ./src/checklist/ChecklistImagesForm.tsx